// extracted by mini-css-extract-plugin
export default {"circularImage":"circular-button_circularImage__xzfON","image":"circular-button_image__Vl4XP","grayOverlay":"circular-button_grayOverlay__RqMRK"};